import { createContext, FC, PropsWithChildren, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { ColorValues, Theme } from 'Types';

export const ThemeContext = createContext((_theme: Theme) => {});

export const ThemeLayout: FC<PropsWithChildren> = ({ children }) => {
	const initialTheme: Theme = {
		businessPartner: {
			defaultPrimaryColor: '#ffb471',
			primaryColor: '#ffb471'
		},
		communityPartner: {
			defaultPrimaryColor: ColorValues.tertiary,
			primaryColor: ColorValues.tertiary
		},
		defaultPrimaryColor: ColorValues.primary,
		colorGray1: ColorValues['gray-1'],
		colorGray2: ColorValues['gray-2'],
		colorGray3: ColorValues['gray-3'],
		colorGray4: ColorValues['gray-4'],
		colorGray5: ColorValues['gray-5']
	};
	const [theme, setTheme] = useState<Theme>(initialTheme);

	return (
		<ThemeProvider theme={theme}>
			<ThemeContext.Provider value={setTheme}>
				{children}
			</ThemeContext.Provider>
		</ThemeProvider>
	);
};
